import { ContainerComponent, today, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { TimeSpanRow } from 'molecules';
import { GenericWrapper } from 'wrappers';
import { format, addDays, addYears, addMonths } from 'date-fns';

export const definition = {
  name: 'DatePickerButtons',
  controller: Controller,
  initialProps: ({ selectedDate, selectedTimeOption, displayIcon, isModal }) => (
    { selectedTimeOption, displayIcon, isModal, selectedDate }
  ),
  props: internalState,
  elements: [
    {
      component: TimeSpanRow,
      name: 'Today',
      bindings: ({ selectedTimeOption, displayIcon }) => ({
        label: 'Today',
        selected: selectedTimeOption === 'today',
        displayIcon
      }),
      displayState: ({ selectedTimeOption, isModal }) => ({ selected: selectedTimeOption === 'today', padding: isModal ? '10px' : '15px' })
    },
    {
      component: TimeSpanRow,
      name: 'Tomorrow',
      bindings: ({ selectedTimeOption, displayIcon }) => ({
        label: 'Tomorrow',
        singleDate: format(addDays(today(), 1), 'MM/dd/yy'),
        selected: selectedTimeOption === 'tomorrow',
        displayIcon
      }),
      displayState: ({ selectedTimeOption, isModal }) => ({ selected: selectedTimeOption === 'tomorrow', padding: isModal ? '10px' : '15px' })
    },
    {
      component: TimeSpanRow,
      name: 'NextWeek',
      bindings: ({ selectedTimeOption, displayIcon }) => ({
        label: 'Next Week',
        singleDate: format(addDays(today(), 7), 'MM/dd/yy'),
        selected: selectedTimeOption === 'nextWeek',
        displayIcon
      }),
      displayState: ({ selectedTimeOption, isModal }) => ({ selected: selectedTimeOption === 'nextWeek', padding: isModal ? '10px' : '15px' })
    },
    {
      component: TimeSpanRow,
      name: 'NextMonth',
      bindings: ({ selectedTimeOption, displayIcon }) => ({
        label: 'Next Month',
        singleDate: format(addMonths(today(), 1), 'MM/dd/yy'),
        selected: selectedTimeOption === 'nextMonth',
        displayIcon
      }),
      displayState: ({ selectedTimeOption, isModal }) => ({ selected: selectedTimeOption === 'nextMonth', padding: isModal ? '10px' : '15px' })
    },
    {
      component: TimeSpanRow,
      name: 'NextQuarter',
      bindings: ({ selectedTimeOption, displayIcon }) => ({
        label: 'Next Quarter',
        selected: selectedTimeOption === 'nextQuarter',
        singleDate: format(addMonths(today(), 3), 'MM/dd/yy'),
        displayIcon
      }),
      displayState: ({ selectedTimeOption, isModal }) => ({ selected: selectedTimeOption === 'nextQuarter', padding: isModal ? '10px' : '15px' })
    },
    {
      component: TimeSpanRow,
      name: 'NextYear',
      bindings: ({ selectedTimeOption, displayIcon }) => ({
        label: 'Next Year',
        selected: selectedTimeOption === 'nextYear',
        singleDate: format(addYears(today(), 1), 'MM/dd/yy'),
        displayIcon
      }),
      displayState: ({ selectedTimeOption, isModal }) => ({ selected: selectedTimeOption === 'nextYear', padding: isModal ? '10px' : '15px' })
    },
    {
      component: TimeSpanRow,
      name: 'Custom',
      bindings: ({ selectedTimeOption, displayIcon, selectedDate }) => ({
        label: 'Custom',
        selected: selectedTimeOption === 'custom',
        displayIcon,
        selectedDate
      }),
      displayState: ({ selectedTimeOption, isModal }) => ({ selected: selectedTimeOption === 'custom', padding: isModal ? '10px' : '15px' })
    }
  ]
};

export default wrap(ContainerComponent(definition), GenericWrapper);